import { FC, useRef } from 'react';

import { Divider, Tooltip, Typography } from '@mui/material';

const ShoppingCartSubtitle: FC<{ body: string; hasDivider?: boolean }> = ({ body, hasDivider }) => {
  const ref = useRef<HTMLSpanElement>(null);

  return (
    <>
      <Tooltip
        title={(ref.current?.scrollWidth ?? 0) > (ref.current?.clientWidth ?? 0) ? body : ''}
        placement="top"
      >
        <Typography
          component="span"
          ref={ref}
          sx={{
            fontSize: '0.625rem',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            maxWidth: '6rem',
          }}
        >
          {body}
        </Typography>
      </Tooltip>

      {hasDivider && <Divider orientation="vertical" flexItem sx={{ margin: '0 0.125rem' }} />}
    </>
  );
};

export default ShoppingCartSubtitle;
